import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-service-message" }

import { computed } from '../../../adapter-vue';
import { IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { JSONToObject } from '../../../utils/type-check';

interface IProps {
  message: IMessageModel;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'message-customer-service',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props;

const displayText = computed(() => {
  const payloadData = JSONToObject(props.message?.payload?.data);
  return payloadData?.text || payloadData?.content || payloadData?.description || '[客服消息]';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(displayText)), 1))
}
}

})